import './App.css'
import { GetToken } from './components/GetToken'
import TokenContext from './components/TokenContext'
import { useEffect, useState } from 'react'
import {
  createBrowserRouter,
  RouterProvider,
  Route,
} from "react-router-dom";
import { Ranks } from './components/Ranks'

const router = createBrowserRouter([
  {
    path: "/",
    element: <GetToken />,
  },
  {
    path: "rents/",
    element: <Ranks />,
  },
]);


function App () {
  let [token, setToken] = useState(null)
  useEffect(() => {
    const query = new URLSearchParams(window.location.search)
    const queryToken = query.get('token')
    if (queryToken) {
      setToken(queryToken)
    }
  }, [setToken])
  return (
    <div className="App">
      <TokenContext.Provider value={token}>
         <RouterProvider router={router} />
      </TokenContext.Provider>
    </div>
  )
}

export default App
